import atoms from "../../../atoms";
import constant from "../../../../constants/constant";
import { findConstantLabel } from "../../../../constants/utils";
import moment from "moment";
import { OrgMovementPendingProps, TableData } from "./interface";
import { RiDeleteBin6Line } from "react-icons/ri";
const { Search, Button, Table, Pagination, CustomImages } = atoms;

const Index = ({
    setSearch,
    pendingListing,
    setLimitPerPage,
    setCurrentPage,
    currentPage,
    limit,
    _handleEdit,
    handleCancel
}: OrgMovementPendingProps) => {
    const columns = [
        {
            name: "Product ID",
            selector: (row: TableData) => row.product.product_id_display,
            minWidth: "150px",
        },
        {
            name: "Movement ID",
            selector: (row: TableData) => row.procurement.procurement_display_id || "-",
            minWidth: "110px",
        },
        {
            name: "Date Time",
            selector: (row: TableData) =>
                `${row?.createdAt
                    ? moment(row?.updatedAt).format("DD/MM/YYYY , H:mm:ss")
                    : "--"
                }`,
            sortable: true,
            minWidth: "120px",
        },
        {
            name: "Cover Photo",
            cell: (row: any) => (
                <CustomImages
                    src={row?.product?.images?.length > 0 && row?.product?.images[0]}
                    imageHeight={'50px'}
                />
            ),
            center: true,
            minWidth: "150px",
        },
        {
            name: "Product Type / Frame /Glass Size/Power",
            selector: (row: TableData) =>
                `${row?.product?.product_type?.name}
         ${row?.product?.rim_type
                    ? findConstantLabel(
                        constant?.PRODUCT_RIM_TYPE,
                        row?.product?.rim_type
                    )
                    : ""
                }
         ${row?.product?.glass_size}`,
            minWidth: "150px",
        },
        {
            name: "Requested Store Name",
            selector: (row: TableData) => row?.requested_store?.store_location || "",
            minWidth: "180px",
        },
        {
            name: "Order ID/Warranty Claim ID",
            selector: (row: any) =>
                row?.order?.order_id_display
                    ? row?.order?.order_id_display
                    : row?.warranty_claimed_product?.claim_id,

        },
        {
            name: "Cancel Store Name",
            selector: (row: TableData) => row?.cancelled_by || "-",
            minWidth: "140px",
        },
        {
            name: "Cancel Reason",
            selector: (row: TableData) => row?.cancel_reason || "-",
            minWidth: "130px",
        },
        { name: "Action", selector: (row: TableData) => row.action, minWidth: "300px" },
    ];

    return (
        <div>
            <div className="row align-items-center">
                <div className="col-6">
                    <Search
                        searchCallBack={(e: string) => {
                            setSearch(e);
                        }}
                    />
                </div>
            </div>
            <div>
                <Table
                    AdditionalClassName="add-invertory-table data-table-container"
                    columns={columns}
                    data={pendingListing?.data?.map((item) => {
                        return {
                            ...item,
                            action: (
                                <div style={{ overflow: "unset", textOverflow: "unset" }}>
                                    <Button
                                        className="table-edit-button fs-14 fw-400"
                                        onClick={() => {
                                            _handleEdit(item.id);
                                        }}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="ms-2 mb-0">Assign to store</span>
                                        </div>
                                    </Button>
                                    <Button className="table-delete-button fs-14 fw-400 ms-3"
                                        onClick={() => handleCancel(item.id)}>
                                        <div className='d-flex align-items-center'>
                                            <RiDeleteBin6Line />
                                            <span className='ms-2 mb-0'>Cancel</span>
                                        </div>
                                    </Button>
                                </div>
                            ),
                        };
                    })}
                />
            </div>
            <div>
                <Pagination
                    totalCount={pendingListing?.count}
                    currentPage={currentPage}
                    totalPages={pendingListing?.totalPages}
                    onChangePage={(page: number) => setCurrentPage(page)}
                    setLimit={(e: number) => setLimitPerPage(e)}
                    limit={limit}
                />
            </div>
        </div>
    );
};

export default Index;
